import { useEffect, useState } from 'react';

import { colors } from 'inpock-ui-react/dist/src/color';
import styled from '@emotion/styled';
import { css } from '@emotion/react';

import CheckDisabled from '@/assets/icons/icon-check-disabled.svg';
import Check from '@/assets/icons/icon-check.svg';

interface SelectBoxProps {
  className?: string;
  style?: React.CSSProperties;
  name?: string;
  value: boolean;
  onInput?: (value: boolean, name?: string) => void;
  disabled?: boolean;
}

export function SelectBox(props: SelectBoxProps) {
  const [value, setValue] = useState(props.value);

  const handleOnClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.stopPropagation();
    if (props.disabled) {
      return;
    }
    props.onInput && props.onInput(!value, props.name);
    setValue(!value);
  };

  useEffect(() => {
    if (props.value !== value) setValue(props.value);
  }, [props.value]);

  return (
    <StyledSelectBox
      className={props.disabled ? 'disabled' : ''}
      name={props.name}
      checked={value}
      type="button"
      style={props.style}
      onClick={handleOnClick}
    />
  );
}

const StyledSelectBox = styled.button<{ checked: boolean }>`
  --select-size: 16px;

  width: var(--select-size);
  min-width: var(--select-size);
  height: var(--select-size);
  padding: 0;
  margin: 0;
  background-repeat: no-repeat;
  background-position: center;
  border: none;
  background-color: transparent;
  border-radius: 4px; /* Adjust border-radius as needed */
  cursor: pointer;

  &.disabled {
    cursor: not-allowed;

    &:before {
      content: '';
      display: inline-block;
      width: calc(var(--select-size) + 2px);
      height: calc(var(--select-size) + 2px);
      background-image: url(${CheckDisabled});
      background-repeat: no-repeat;
      background-position: center;
      background-size: calc(var(--select-size) + 2px) calc(var(--select-size) + 2px);
    }
  }

  ${(props) =>
    props.checked
      ? css`
          &:before {
            content: '';
            display: inline-block;
            width: var(--select-size);
            height: var(--select-size);
            border: 1px solid ${colors.gray400};
            border-radius: 4px;
            vertical-align: middle;
            border: 1px solid ${colors.orange900};
            background-image: url(${Check});
            background-repeat: no-repeat;
            background-position: center;
            background-color: white;
          }
        `
      : css`
          &.disabled {
            &:before {
              border: none;
            }
          }

          &:before {
            content: '';
            display: inline-block;
            width: var(--select-size);
            height: var(--select-size);
            border: 1px solid ${colors.gray400};
            border-radius: 4px;
            vertical-align: middle;
          }
        `}
`;
